export const BG = "#FFFFFF";
export const FG = "#3A3F51";
export const BORDER = "#E5E7EB";
export const SCROLL_THMB = "#c5c9d4";
export const GRADIENT = "linear-gradient(135deg, #2DD4BF 0%, #22D3EE 45%, #C026D3 100%)";
// Exact 5-stop gradient from the design file (top-to-bottom), used on the
// collapsed tab.
export const TAB_GRADIENT =
  "linear-gradient(180deg, #64E4DD 0%, #5377D4 35%, #4E5CD2 55%, #786ACD 75%, #FF96BE 100%)";
// Exact gradient of the send CTA / sparkle icon (sampled from the design asset:
// coral → pink → purple → blue → cyan), for horizontal surfaces like the
// "New chat" pill so it matches SendCtaIcon / SparkleGradientIcon.
export const BRAND_GRADIENT =
  "linear-gradient(90deg, #FF614C 0%, #FF8E8B 17.31%, #FF96BE 34.62%, #4D54D1 58.17%, #64E4DD 100%)";
export const PANEL_WIDTH = 498;
// Default panel height, used both in a conversation and on the welcome screen (kept the
// same in both so starting a chat from a quick action never resizes the panel). Sized
// tall enough that the welcome screen's quick-actions grid never needs to scroll — tune
// this if a new quick action is added, or the action cards' min-height changes, and it
// starts scrolling again.
export const PANEL_HEIGHT = 900;
// Width of the panel when the user expands it (or when a wide table asks for
// room). Capped to the viewport so it never overflows on small screens.
export const EXPANDED_PANEL_WIDTH = 870;
// Height of the panel when the user expands it over content that grows tall instead
// of wide (e.g. an approval card with a long diff). Capped to the viewport so it never
// overflows on small screens.
export const EXPANDED_PANEL_HEIGHT = 1100;
// Charcoal used by the widget action buttons ("Expand table" / "Export to XLSX").
export const DARK_BTN = "#33384A";
export const DARK_BTN_HOVER = "#3F4557";
// Accent used by the context chip / pin icon.
export const CONTEXT_ACCENT = "#4D54D1";
